import { TFuncKey } from "react-i18next";

import { GridImage, GridImageDocument } from "../../components/PhotoGrid/types";

export const documentToImagesMap: {
  [K in GridImageDocument]: {
    src: string;
    caption: TFuncKey<"default">;
    id: string;
    alt: string;
  }[];
} = {
  itAccidentCircumstance: [
    {
      id: "itAccidentCircumstance",
      alt: "Accident circumstance",
      src: "/assets/jpg/additionalDocuments/accident-circumstance.jpg",
      caption: "additional_documents.it_accident_circumstance",
    },
  ],
  itRegistrationCertificate: [
    {
      id: "itRegistrationCertificate",
      alt: "Registration certificate",
      src: "/assets/jpg/additionalDocuments/registration-certificate.jpg",
      caption: "additional_documents.it_registration_certificate",
    },
  ],
  jpCarCertificate: [
    {
      id: "jpCarCertificatePaper",
      alt: "Car certificate paper",
      src: "/assets/jpg/additionalDocuments/jpCarCertificatePaper.jpg",
      caption: "additional_documents.jp_car_certificate_paper",
    },
    {
      id: "jpCarCertificateCard",
      alt: "Car certificate card",
      src: "/assets/jpg/additionalDocuments/jpCarCertificateCard.jpg",
      caption: "additional_documents.jp_car_certificate_card",
    },
  ],
  plAccidentStatement: [
    {
      id: "plAccidentStatement",
      alt: "Accident Statement",
      src: "/assets/jpg/additionalDocuments/plAccidentStatement.jpg",
      caption: "additional_documents.pl_accident_statement",
    },
  ],
  plDriversLicense: [
    {
      id: "plDriversLicenseObverse",
      alt: "Driver's license obverse",
      src: "/assets/jpg/additionalDocuments/plDriversLicenseObverse.jpg",
      caption: "additional_documents.pl_drivers_license_obverse",
    },
    {
      id: "plDriversLicenseReverse",
      alt: "Driver's license reverse",
      src: "/assets/jpg/additionalDocuments/plDriversLicenseReverse.jpg",
      caption: "additional_documents.pl_drivers_license_reverse",
    },
  ],
  plAccidentDocument: [
    {
      id: "plAccidentDocument",
      alt: "Statement from the perpetrator or police note",
      src: "/assets/jpg/additionalDocuments/plAccidentDocument.jpg",
      caption: "additional_documents.pl_accident_document",
    },
  ],
  plCarRegistrationCertificate: [
    {
      id: "plCarRegistrationCertificateObverse",
      alt: "Car registration certificate front",
      src: "/assets/jpg/additionalDocuments/plCarRegistrationCertificateObverse.jpg",
      caption: "additional_documents.pl_car_registration_certificate_obverse",
    },
    {
      id: "plCarRegistrationCertificateReverse",
      alt: "Car registration certificate reverse",
      src: "/assets/jpg/additionalDocuments/plCarRegistrationCertificateReverse.jpg",
      caption: "additional_documents.pl_car_registration_certificate_reverse",
    },
  ],
  link4AccidentStatement: [
    {
      id: "link4AccidentStatement",
      alt: "Accident Statement",
      src: "/assets/jpg/additionalDocuments/link4AccidentStatement.jpg",
      caption: "additional_documents.pl_accident_statement",
    },
  ],
};

export const documentToImages = (document: GridImageDocument): GridImage[] => documentToImagesMap[document];
